import { generatedThemes } from '../__generated__';
import type { GeneratedTheme, ThemePresets } from '../types';

const getGeneratedTheme = (preset: ThemePresets): GeneratedTheme =>
  generatedThemes[preset];

export default getGeneratedTheme;
